import WonderType from "@/roc/wonders/base/WonderType";
import WonderKind from "@/roc/wonders/base/WonderKind";
import WonderOwner from "@/roc/wonders/base/WonderOwner";
import Effects from '@/roc/effects/Effects';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import TriggeredProduction from '@/roc/effects/Production/TriggeredProduction';
import EffectAmount from '@/roc/effects/EffectAmount';
import ProcCondition from '@/roc/effects/Production/ProcCondition';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import Synergy from '@/roc/wonders/base/Synergy';
import EraType from '@/roc/era/EraType';

const TombOfMausolus = {
  id: '55',
  name: 'Tomb of Mausolus',
  era: EraType.bronzeAge,
  icon: 'tom',
  minLevel: 1,
  maxLevel: 30,
  type: WonderType.ANCIENT_WORLD,
  kind: WonderKind.TEMPLE,
  kindMultiplier: 1,
  owner: WonderOwner.CAPITAL,
  effects: Effects.create([
    new TriggeredProduction(
      EffectAmount.asFlat(5),
      ProcCondition.asFinishTask(),
      ProductionDuration.asDaily(),
      ProductionOutput.asFlat(1).withOutput(ProductionOutputType.CHEST),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerLevel([
        300,
        330,
        360,
        390,
        420, // 5
        450,
        480,
        510,
        540,
        570, // 10
        600,
        630,
        660,
        690,
        720, // 15
        750,
        780,
        810,
        840,
        870, // 20
        900,
        930,
        960,
        990,
        1020, // 25
        1050,
        1080,
        1110,
        1140,
        1170  // 30
      ]).withOutput(ProductionOutputType.ALL_CURRENT_ERA_GOODS),
    ),
  ]),
  synergies: [
    {
      effectIndex: 1,
      mod: Synergy.asFlat(100).withKind(WonderKind.TEMPLE),
      effect: null,
    }
  ],
};

export default TombOfMausolus;
